module.exports = __webpack_public_path__ + "static/img/pattern04.43fc2dc1.png";